<template>
  <div class="worper">
    <div id="J_prismPlayer"></div>
    <div class="group">
      <div class="group-name">
        <span class="group-border"></span>
        <span class="group-text">{{ videoName }}</span>
      </div>
      <div class="group-paragraph" v-if='videoDescription != " " && videoDescription != null '>
        <div class="group-profile">简介</div>
        <span class="profile-text">{{ videoDescription }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  data() {
    return {
      playAuth: "",
      videoName: "",
      videoDescription: "",
    };
  },
  mounted() {
    this.getVideoPlayAuth();
  },
  methods: {
    getVideoPlayAuth() {
      api.moveclassrorm.getVideoPlayAuth(this.$route.query.vid).then((res) => {
        if (res.code === 0) {
          this.playAuth = res.playAuth;
          this.videoName = res.videoName;
          this.videoDescription = res.videoDescription;
          this.play();
        }
      });
    },

    play() {
      var player = new Aliplayer(
        {
          id: "J_prismPlayer",
          width: "100%",
          vid: this.$route.query.vid, //必选参数。音视频ID。示例：1e067a2831b641db90d570b6480f****。
          playauth: this.playAuth, //必选参数。音视频播放凭证。
          qualitySort: "asc",
          format: "mp4",
          mediaType: "video",
          width: "100%",
          // height: "500px",
          autoplay: true,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          loadDataTimeout: "10000",
          controlBarVisibility: "click",
          showBarTime: 3000,
          useH5Prism: true,
          skinLayout: [
            {
              name: "bigPlayButton",
              align: "blabs",
              x: 30,
              y: 80,
            },
            {
              name: "H5Loading",
              align: "cc",
            },
            {
              name: "errorDisplay",
              align: "tlabs",
              x: 0,
              y: 0,
            },
            {
              name: "infoDisplay",
            },
            {
              name: "tooltip",
              align: "blabs",
              x: 0,
              y: 56,
            },
            {
              name: "controlBar",
              align: "blabs",
              x: 0,
              y: 0,
              children: [
                {
                  name: "progress",
                  align: "blabs",
                  x: 0,
                  y: 44,
                },
                {
                  name: "playButton",
                  align: "tl",
                  x: 15,
                  y: 12,
                },
                {
                  name: "timeDisplay",
                  align: "tl",
                  x: 10,
                  y: 7,
                },
                {
                  name: "fullScreenButton",
                  align: "tr",
                  x: 10,
                  y: 12,
                },
                {
                  name: "setting",
                  align: "tr",
                  x: 15,
                  y: 12,
                },
                {
                  name: "volume",
                  align: "tr",
                  x: 5,
                  y: 10,
                },
              ],
            },
          ],
        },
        function (player) {
          console.log(player, "//////");
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.worper {
  background-color: #fff;
  height: 100%;
  .group {
    margin-left: 2.666666vw;
    .group-name {
      margin-top: 2vw;
      .group-border {
        // display: inherit;
        // display: initial;
        display: inline-block;
        width: 0.7999998vw;
        height: 3.8666657vw;
        background-color: #fff;
        margin-top: 2.5333327vw;
        // padding: 15vw;
        margin-right: 1.333333vw;
      }
      .group-text {
        display: inline;
        font-size: 3.999999vw;
        font-weight: 600;
        margin-top: -0.5vw;
        // padding-top: -0.5vw;
      }
    }
    .group-paragraph {
      width: 90%;
      margin-left: 2.1333328vw;
      margin-top: 2.5333327vw;
      .group-profile {
        padding-top: 1vw;
        color: #333;
        font-size: 3.6666658vw;
        font-weight: 600;
        padding-bottom: 2vw;
      }
      .profile-text {
        // padding-top: 3vw;
        color: #666666;
        font-size: 3.4666658vw;
      }
    }
  }
}
</style>